<script setup>
import { computed, ref, watch } from 'vue';

const props = defineProps({
    modelValue: {
        type: Object,
        default: null,
    },
    options: {
        type: Array,
        default: () => [],
    },
    erro: {
        type: String,
        default: null,
    },
    titulo: {
        type: String,
        default: 'Projeto',
    },
    obrigatorio: {
        type: Boolean,
        default: true,
    },
    mostrarTitulo: {
        type: Boolean,
        default: true,
    },
    // Fora dos formularios (cabecalho de listagem, por exemplo) o espacamento de 'field col-12' atrapalha
    // e o campo passa a acompanhar a altura dos demais controles do cabecalho
    usarClasseCampo: {
        type: Boolean,
        default: true,
    },
    placeholder: {
        type: String,
        default: 'Selecione o projeto',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    loading: {
        type: Boolean,
        default: false,
    },
    showClear: {
        type: Boolean,
        default: false,
    },
    id: {
        type: String,
        default: 'projeto-campo',
    },
    // Campos extras da busca, para telas que pesquisam por orgao contratante ou codigo
    filterFields: {
        type: Array,
        default: () => ['titulo', 'numero'],
    },
    // Onde o painel de opcoes e renderizado; 'body' e o padrao do PrimeVue e 'self' prende no proprio campo
    appendTo: {
        type: String,
        default: 'body',
    },
});

// Fora do formulario o campo usa a mesma altura e fonte do campo de busca das listagens
const estiloInput = computed(() =>
    props.usarClasseCampo ? null : 'padding: 0.57rem 0.75rem; font-size: 0.875rem;'
);

const emit = defineEmits(['update:modelValue', 'change']);

const projetoSelecionado = ref(props.modelValue);

watch(() => props.modelValue, (novoValor) => {
    if (novoValor !== projetoSelecionado.value) {
        projetoSelecionado.value = novoValor;
    }
});

const selecionarProjeto = (event) => {
    const valor = event && typeof event.value === 'object' ? event.value : null;
    emit('update:modelValue', valor);
    emit('change', valor);
};
</script>

<template>
    <div :class="props.usarClasseCampo ? 'field mb-2 col-12' : ''" :id="props.id">
        <SmallTitle v-if="props.mostrarTitulo" :titulo="props.titulo" :obrigatorio="props.obrigatorio" />
        <Dropdown v-model="projetoSelecionado" :options="props.options" filter :filterFields="props.filterFields"
            :appendTo="props.appendTo"
            optionLabel="titulo" :loading="props.loading" :disabled="props.disabled" :placeholder="props.placeholder"
            :showClear="props.showClear" :class="{ 'p-invalid': props.erro }" class="text-sm w-full"
            emptyFilterMessage="Nenhum projeto encontrado" :pt="{ input: { class: 'text-sm', style: estiloInput } }"
            @change="selecionarProjeto">
            <template #value="slotProps">
                <div v-if="slotProps.value" class="flex align-items-center gap-2">
                    <div class="text-sm">Projeto {{ slotProps.value.numero }}</div>
                    <AvisoCoordenadorForaVigencia v-if="slotProps.value.coordenador_fora_vigencia" icone />
                </div>
                <span v-else class="text-sm">{{ slotProps.placeholder }}</span>
            </template>
            <template #option="slotProps">
                <div class="flex flex-column">
                    <span class="flex align-items-center gap-2 text-sm font-semibold text-800">
                        Projeto {{ slotProps.option.numero }}
                        <AvisoCoordenadorForaVigencia v-if="slotProps.option.coordenador_fora_vigencia" icone />
                    </span>
                    <div class="text-500 mt-1" style="line-height: 0.8rem; font-size: 11px !important;">
                        {{ slotProps.option.titulo }}
                    </div>
                </div>
            </template>
        </Dropdown>
        <SmallError :error="props.erro" />
    </div>
</template>
